(function(){
var root=document.querySelector('.ftp');if(!root)return;
var main=root.querySelector('#ftmain'),stage=root.querySelector('.stage');
var vars=[];try{vars=JSON.parse(document.getElementById('ftvars').textContent)}catch(e){}
if(!vars.length)return;
var ths=[].slice.call(root.querySelectorAll('.th'));
var groups=[].slice.call(root.querySelectorAll('.opt'));
var idEl=root.querySelector('#ftid'),priceEl=root.querySelector('#ftprice'),wasEl=root.querySelector('#ftwas'),saveEl=root.querySelector('#ftsave');
var btn=root.querySelector('#ftbuy'),btxt=root.querySelector('#ftbtxt'),bp=root.querySelector('#ftbp');
var sp=document.getElementById('ftsprice'),sb=document.getElementById('ftsbuy'),sl=document.getElementById('ftslab');
var countEl=root.querySelector('#ftcount');
var ci=-1;groups.forEach(function(g,i){if(g.dataset.kind==='color')ci=i});

/* ---------- colour swatches ---------- */
var COLORS={'black':'#121214','black beauty':'#0d0d10','navy blue':'#1c2b4d','royal blue':'#2c58d1','sky blue':'#8dbdea','light blue':'#b9d5ef','medium blue':'#5f92d2','gray blue':'#7c90a8','grey blue':'#7c90a8','gray':'#8c8f94','grey':'#8c8f94','dark gray':'#4b4e53','dark grey':'#4b4e53','charcoal gray':'#34373c','charcoal grey':'#34373c','greyish white':'#e6e5e1','white':'#f3f3f1','rain washed':'#b0b6bb','khaki':'#b8a578','apricot':'#f0b07a','mild apricot':'#f4cca2','light apricot':'#f8dcc0','coffee':'#6a4a36','dark brown':'#4a3123','brown':'#7a5238','dark purple':'#3e2a57','purple':'#6a4a9a','pink':'#f2a4b9','wine red':'#6e1a2c','red':'#c0262d','green':'#2f6b4a','olive':'#6b6b3a','beige':'#d8c8a8','cream':'#efe6d2','silver':'#c9ccd1','orange':'#e8793a','yellow':'#e8c23a','blue':'#2f5bd3'};
function colorFor(n){var k=(n||'').toLowerCase().trim();if(COLORS[k])return COLORS[k];var c=k.replace(/\s+/g,'');if(window.CSS&&CSS.supports&&CSS.supports('color',c))return c;var last=k.split(/\s+/).pop();return COLORS[last]||'#6b6b72'}
root.querySelectorAll('.sw').forEach(function(s){s.style.setProperty('--c',colorFor(s.dataset.v))});

/* ---------- gallery ---------- */
function base(u){return (u||'').split('?')[0]}
var tok=0;
function sync(u){var idx=0;ths.forEach(function(t,i){var on=base(t.dataset.src)===base(u);t.setAttribute('aria-pressed',on);if(on){idx=i;try{t.scrollIntoView({block:'nearest',inline:'nearest'})}catch(e){}}});if(countEl&&ths.length)countEl.textContent=(idx+1)+' / '+ths.length}
function setImg(src){
  if(!main||!src)return;
  if(base(main.src)===base(src)&&main.style.opacity!=='0'){sync(src);return}
  var t=++tok;main.style.opacity='0';
  var im=new Image();
  var done=function(){if(t!==tok)return;main.src=src;main.style.opacity='1';if(stage)stage.style.setProperty('--img',"url('"+src+"')");sync(src)};
  im.onload=done;im.onerror=done;im.src=src;
}
function curIdx(){for(var i=0;i<ths.length;i++){if(ths[i].getAttribute('aria-pressed')==='true')return i}return 0}
function go(i){if(!ths.length)return;i=(i+ths.length)%ths.length;setImg(ths[i].dataset.src)}
ths.forEach(function(t){t.addEventListener('click',function(){setImg(t.dataset.src)})});
var pv=root.querySelector('.nav.prev'),nx=root.querySelector('.nav.next');
if(pv)pv.addEventListener('click',function(){go(curIdx()-1)});
if(nx)nx.addEventListener('click',function(){go(curIdx()+1)});
var sx=null;
if(stage){
  stage.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
  stage.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;sx=null;if(Math.abs(dx)>45)go(curIdx()+(dx<0?1:-1))},{passive:true});
}

/* ---------- variants & colour -> picture ---------- */
function score(c,t){
  var a=((t.dataset.alt||'')+' '+(base(t.dataset.src).split('/').pop()||'')).toLowerCase().replace(/[-_.]+/g,' ');
  var f=(c||'').toLowerCase();if(!f)return 0;
  if(a.indexOf(f)>-1)return 3;
  return f.split(/\s+/).every(function(w){return a.indexOf(w)>-1})?2:0;
}
function resolve(v){
  if(v.img)return v.img;
  if(ci<0)return null;
  var c=v.options[ci],k;
  for(k=0;k<vars.length;k++){if(vars[k].options[ci]===c&&vars[k].img)return vars[k].img}
  var best=null,bs=0;
  ths.forEach(function(t){var s=score(c,t);if(s>bs){bs=s;best=t.dataset.src}});
  return best;
}
function sel(){return groups.map(function(g){var b=g.querySelector('[data-v][aria-pressed="true"]');return b?b.dataset.v:''})}
function findVar(s){return vars.filter(function(v){return s.every(function(x,i){return v.options[i]===x})})[0]}
function setSel(o){groups.forEach(function(g,i){g.querySelectorAll('[data-v]').forEach(function(b){b.setAttribute('aria-pressed',b.dataset.v===o[i])});var l=g.querySelector('.oval');if(l)l.textContent=o[i]})}
function mark(s){
  groups.forEach(function(g,gi){g.querySelectorAll('[data-v]').forEach(function(b){
    var ok=vars.some(function(x){return x.available&&x.options[gi]===b.dataset.v&&s.every(function(o,j){return j===gi||x.options[j]===o})});
    b.classList.toggle('is-out',!ok);
  })});
}
function update(v){
  idEl.value=v.id;priceEl.textContent=v.price_f;
  if(v.compare>v.price){wasEl.textContent=v.compare_f;wasEl.hidden=false;saveEl.textContent='Save '+Math.round((1-v.price/v.compare)*100)+'%';saveEl.hidden=false}else{wasEl.hidden=true;saveEl.hidden=true}
  btn.disabled=!v.available;btxt.textContent=v.available?'Add to cart':'Sold out';bp.textContent=v.available?'\u00b7 '+v.price_f:'';
  if(sp)sp.textContent=v.price_f;
  if(sb){sb.disabled=!v.available;sb.textContent=v.available?'Add to cart':'Sold out'}
  if(sl)sl.textContent=v.options.join(' \u00b7 ');
  try{if(history.replaceState)history.replaceState(null,'',location.pathname+'?variant='+v.id)}catch(e){}
}

var cur=vars[0];
if(groups.length){
  var s0=sel();cur=findVar(s0)||vars[0];
  var hasParam=/[?&]variant=/.test(location.search);
  if(!hasParam&&ths[0]){
    /* open on the colour that matches the product's first photo */
    var fb=base(ths[0].dataset.src);
    var m=vars.filter(function(x){return x.img&&base(x.img)===fb})[0];
    if(!m&&ci>=0){var bc=null,bsc=0;vars.forEach(function(x){var sc=score(x.options[ci],ths[0]);if(sc>bsc&&x.available){bsc=sc;bc=x}});m=bc}
    if(m&&m.available)cur=m;
  }
  setSel(cur.options);mark(cur.options);update(cur);
  if(hasParam){var ri=resolve(cur);if(ri)setImg(ri)}
}else{update(cur)}
if(ths.length)sync(main?main.src:'');

groups.forEach(function(g,gi){
  g.querySelectorAll('[data-v]').forEach(function(b){
    b.addEventListener('click',function(){
      var s=sel();s[gi]=b.dataset.v;
      var v=findVar(s);
      if(!v){var best=null,bs=-1;vars.forEach(function(x){if(x.options[gi]!==b.dataset.v)return;var sc=x.options.reduce(function(a,o,i){return a+(o===s[i]?1:0)},0)+(x.available?.5:0);if(sc>bs){bs=sc;best=x}});v=best}
      if(!v)return;
      setSel(v.options);mark(v.options);update(v);
      if(gi===ci){var im=resolve(v);if(im)setImg(im)}
    });
  });
});

/* ---------- quantity, sticky bar, size guide ---------- */
var qi=root.querySelector('#ftqty');
root.querySelectorAll('.qty button').forEach(function(b){b.addEventListener('click',function(){var n=parseInt(qi.value||'1',10)+(b.dataset.d==='+'?1:-1);qi.value=Math.max(1,n)})});
var bar=document.getElementById('ftsticky');
if(bar&&btn&&'IntersectionObserver' in window){new IntersectionObserver(function(es){bar.classList.toggle('show',!es[0].isIntersecting)}).observe(btn)}
if(sb)sb.addEventListener('click',function(){btn.click()});
var dlg=document.getElementById('ftsize'),sbtn=document.getElementById('ftsizebtn');
if(dlg&&sbtn){
  sbtn.addEventListener('click',function(){if(dlg.showModal)dlg.showModal();else dlg.setAttribute('open','')});
  dlg.querySelector('.x').addEventListener('click',function(){dlg.close?dlg.close():dlg.removeAttribute('open')});
  dlg.addEventListener('click',function(e){if(e.target===dlg&&dlg.close)dlg.close()});
}
})();